
import React from "react";
import unslugify from "unslugify";
export const renderAddons = (addons) => {
    const categories = [...new Set(addons.map(a => a.attachedAddonCat || '-'))];
    // console.log("categories",categories)

    return categories.map((cat, i) => {
        const items = addons.filter(a => (a.attachedAddonCat || '-') === cat);
        // console.log("items",items)

        return (
            <React.Fragment key={cat}>
                <span style={{ fontWeight: "bold" }}>
                    {unslugify(cat)}
                </span>
                :{" "}

                {/* Items ke beech | */}
                {items.map((a, idx) => (
                    <React.Fragment key={a.serviceId}>
                        <span style={{ fontWeight: "normal" }}>
                            {a.serviceName} [{a.isCustomQty ? a.qty : 1}x]
                        </span>

                        {/* | light */}
                        {idx < items.length - 1 && (
                            <span
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "300",
                                    // color: "#999"
                                }}
                            >
                                {" "} | {" "}
                            </span>
                        )}
                    </React.Fragment>
                ))}

                {/* Categories ke beech || */}
                {i < categories.length - 1 && (
                    <span
                        style={{
                            fontSize: "20px",
                            fontWeight: "300",
                            // color: "#999"
                        }}
                    >
                        {" "} || {" "}
                    </span>
                )}
            </React.Fragment>
        );
    });
};
